import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { InformationalType } from "@shared/interfaces/informational.interface";
import { CookieService } from "ngx-cookie-service";
import { Observable, of, tap, throwError } from "rxjs";

@Injectable({ providedIn: "root" })
export class InformationalService {
  private readonly REGISTER_URL: string = environment.registerUrl;
  private readonly COOKIE_PREFIX: string = "broadfactor__informational";
  private readonly COOKIE_EXPIRATION_DAYS: number = 7;

  http = inject(HttpClient);
  cookieService = inject(CookieService);

  markAsViewed(information: InformationalType, companyId?: string): Observable<void> {
    if (!companyId) {
      return throwError(() => new Error("O companyId é obrigatório."));
    }

    const url = `${this.REGISTER_URL}/secure-api/company/${companyId}/notifications/${information}`;

    return this.http.post<void>(url, {}).pipe(
      tap(() => {
        this.setHasViewedCookie(information);
      }),
    );
  }

  hasViewed(information: InformationalType, companyId?: string): Observable<boolean> {
    const hasViewedCookie = this.getHasViewedCookie(information);

    if (hasViewedCookie) {
      return of(true);
    }

    const url = `${this.REGISTER_URL}/secure-api/company/${companyId}/notifications/${information}`;

    return this.http.get<boolean>(url).pipe(
      tap(hasViewed => {
        if (hasViewed) {
          this.setHasViewedCookie(information);
        }
      }),
    );
  }

  setHasViewedCookie(information: InformationalType): void {
    this.cookieService.set(`${this.COOKIE_PREFIX}_${information}`, "true", {
      expires: this.COOKIE_EXPIRATION_DAYS,
    });
  }

  getHasViewedCookie(information: InformationalType): boolean {
    return this.cookieService.check(`${this.COOKIE_PREFIX}_${information}`);
  }

  deleteHasViewedCookie(information: InformationalType): void {
    this.cookieService.delete(`${this.COOKIE_PREFIX}_${information}`);
  }
}
